/**
 * Supabase linkIdentity / OAuth の「既に別ユーザーに紐づいている」判定。
 * AuthService（復帰）と feature-auth（UI 文言）で同じ条件を使う。
 */

const ALREADY_IN_USE_RE =
  /already been registered|already in use|already linked|already exists|identity_already_exists/i;

export function isAlreadyInUseText(text: string | undefined): boolean {
  return ALREADY_IN_USE_RE.test(text ?? '');
}

/** error_code + error_description（または AuthError.message）から衝突かどうか。 */
export function isLinkIdentityConflict(
  code: string,
  description: string,
): boolean {
  return code === 'identity_already_exists' || isAlreadyInUseText(description);
}
